import React from 'react';
import PropTypes from 'prop-types';

import { TableContainer as MUITableContainer } from '@mui/material';

export const TableContainer = props => <MUITableContainer {...props} />;

TableContainer.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType
};

export default TableContainer;
